import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Ticket, TicketSolution } from '../models/ticket.model';

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  private tickets: Ticket[] = [];

  createTicket(ticket: Omit<Ticket, 'id' | 'createdAt'>): Observable<Ticket> {
    const newTicket: Ticket = {
      ...ticket,
      id: Math.random().toString(36).substr(2, 9),
      createdAt: new Date(),
    };
    this.tickets.push(newTicket);
    return of(newTicket);
  }

  getSolutionSuggestion(ticket: Ticket): Observable<TicketSolution> {
    // Mock RAG response
    return of({
      content:
        'To reset your password, click on the "Forgot Password" link on the login page and follow the instructions sent to your email.',
      type: 'information',
      confidence: 0.85,
    });
  }

  closeTicket(ticketId: string): Observable<void> {
    const ticket = this.tickets.find((t) => t.id === ticketId);
    if (ticket) {
      ticket.status = 'closed';
    }
    return of(void 0);
  }
}
